export default __webpack_public_path__ + "media/zurb/img/party/z-396de9c5f4e8bd486e9025f137ea3056.png";